/*eslint-disable no-undef */
/*eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Row, Container, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import ResultCard from './ResultCard';
import SearchFilter from './SearchFilter';
import InLineSearchFilter from './InLineSearchFilter';
import './index.scss';
import ResultsCardSkeleton from '../../skeleton/SearchResultsCard';
import CustomPagination from 'src/Member/components/common/pagination';
import CustomPaginationItemsDisplay from 'src/Member/components/common/pagination/CustomPaginationItemsDisplay';
import {
  setFilterChangeStatus,
  setSearchProviderParams,
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from 'src/redux/member/priceCompareSlice';
import DataNotFound from 'src/Member/components/common/dataNotFound/DataNotFound';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import BottomSideBar from '../../components/bottom-sidebar/BottomSideBar';
import CostBar from '../../components/cost-bar/CostBar';
import {
  getPriceComaperFilters,
  searchProvidersPC,
} from '../../../../../redux/member/api-calls/priceCompare';
import { ToastContainer } from 'react-toastify';

const displayPaginationMininumCount = 10;
const NumberOfItemsSelect = ({
  pagination,
  pageSizeHandler,
  isSuffixMessageVisible,
  dataLength,
}) => (
  <>
    {pagination?.TotalRecords > displayPaginationMininumCount ? (
      <CustomPaginationItemsDisplay
        pageSize={pagination?.PageSize}
        setPageSize={pageSizeHandler}
        prefixMessage="Records per page"
        suffixMessage={
          isSuffixMessageVisible &&
          `Showing ${
            pagination?.PageSize * (pagination?.PageNumber - 1) + 1
          } - ${
            pagination?.PageSize * (pagination?.PageNumber - 1) + dataLength
          } of ${pagination?.TotalRecords} provider results`
        }
      />
    ) : null}
  </>
);

const SearchResults = ({
  coveredCostLoading,
  data,
  pagination,
  isSearchingProviders,
  serachNetworksFor,
  CoveredCostComparePriceArray,
  onResetFiltersClick,
  onApplyFiltersPanelClick,
}) => {
  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(pagination?.PageNumber);
  const [pageSize, setPageSize] = useState(pagination?.PageSize);
  const [searchGenderFilterClicked, setSearchGenderFilterClicked] =
    useState('');
  const [searchDistanceFilterClicked, setSearchDistanceFilterClicked] =
    useState('');
  const [searchLanguageFilterClicked, setSearchLanguageFilterClicked] =
    useState('');
  const [searchFilterBestMatchClicked, setSearchBestMatchFilterClicked] =
    useState('');
  const [accessibilityCurrentPage, setAccessibilityCurrentPage] = useState(0);
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );

  const {
    providerByData: originalProviderByData,
    filters: searchParamsForUIFilters,
    typesOfSpecialtyData,
    networksData,
  } = useSelector(({ priceCompare }) => priceCompare.searchParamsForUI);

  const providerByData = searchParamsForUIFilters?.providerByData
    ? searchParamsForUIFilters?.providerByData
    : originalProviderByData;

  const isExternalProvider = networksData?.ProviderDirectory === 'R';
  const { Provider } = allFilters;
  const {
    showFilterBar,
    noResultsFound,
    showServerError,
    address,
    providerType,
    selectedCheckedItems,
    selectedCheckedRowData,
    searchProviderFiltersChanged,
  } = useSelector(({ priceCompare }) => priceCompare);
  const { DoctorByType, DoctorByName, facilityname, speciality } = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams,
  );

  const getSearchTearm = () => {
    let searchText = `${address}/`;

    if (typesOfSpecialtyData) {
      if (Provider === 'facility') {
        if (providerByData === 'facility-type') {
          searchText +=
            'Facility Type/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        } else {
          searchText +=
            'Facility Name or Tax ID/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        }
      } else {
        if (providerByData === 'doctor-type') {
          searchText +=
            'Doctor Type/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        } else {
          searchText +=
            "Doctor's Name or NPI/" + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        }
      }
    }
    setSearchTerm(searchText);
  };

  const [searchTerm, setSearchTerm] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    getSearchTearm();
  }, [DoctorByType, DoctorByName, speciality, facilityname, address]);

  useEffect(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
  }, [currentPage, pageSize]);

  const pageSizeHandler = (pageSizeInfo) => {
    setPageSize(1);
    dispatch(setSearchProviderParams({ pagenumber: 1 }));
    dispatch(setSearchProviderParams({ pagesize: pageSizeInfo.value }));
    dispatch(setFilterChangeStatus(true));
  };

  const pageChangeHandler = (pageNum) => {
    dispatch(setSearchProviderParams({ pagenumber: pageNum }));
    dispatch(setFilterChangeStatus(true));
  };
  const onChangeGenderEvent = (val) => {
    setSearchGenderFilterClicked(val);
  };
  const onChangeDistanceEvent = (val) => {
    setSearchDistanceFilterClicked(val);
  };
  const onChangeLanguageEvent = (val) => {
    setSearchLanguageFilterClicked(val);
  };
  const onChangeBestMatchEvent = (val) => {
    setSearchBestMatchFilterClicked(val);
  };
  useEffect(() => {
    if (searchProviderFiltersChanged === true) {
      dispatch(setFilterChangeStatus(false));
      dispatch(searchProvidersPC());
      dispatch(getPriceComaperFilters());
    }
  }, [searchProviderFiltersChanged]);

  return (
    <>
      <Container>
        <SearchFilter />
      </Container>

      {/*In line filter */}
      {showFilterBar && (
        <div className="provider-search-filter-container mt-4 mt-md-5 mb-0">
          <Container role="search">
            <InLineSearchFilter
              onChangeGenderEvent={(val) => onChangeGenderEvent(val)}
              onChangeDistanceEvent={(val) => onChangeDistanceEvent(val)}
              onChangeLanguageEvent={(val) => onChangeLanguageEvent(val)}
              onChangeBestMatchEvent={(val) => onChangeBestMatchEvent(val)}
              searchFilterBestMatchClicked={searchFilterBestMatchClicked}
              searchGenderFilterClicked={searchGenderFilterClicked}
              searchDistanceFilterClicked={searchDistanceFilterClicked}
              searchLanguageFilterClicked={searchLanguageFilterClicked}
              onResetFiltersClick={onResetFiltersClick}
              onApplyFiltersPanelClick={onApplyFiltersPanelClick}
            />
          </Container>
        </div>
      )}

      {/*cost bar */}
      {/*<Container role="cost bar" className="cost-bar">
        <CostBar />
      </Container> */}
      <div className="sr-only" role="none" ref={tableRef} tabIndex={-1}>
        Compare Price Provider Results Table
      </div>
      <Container
        className="p-0 price-compare-results-container"
        role="table"
        aria-label="Compare Price Results"
        //aria-describedby="search_results_price_compare"
      >
        {!isSearchingProviders && data && data.length > 0 && (
          <>
            {/*<div
              id="search_results_price_compare"
              className="sr-only"
              aria-hidden={true}
            >
              Compare Price for Provider Results
        </div>*/}
            {pagination && (
              <Row className="my-4">
                <Col md={7} className="display-pagination">
                  {/*<NumberOfItemsSelect
                    pagination={pagination}
                    dataLength={data?.length || 0}
                    pageSizeHandler={pageSizeHandler}
                    isSuffixMessageVisible
                  /> */}
                </Col>
                {pagination?.TotalRecords > displayPaginationMininumCount ? (
                  <Col md={5} className="display-pagination">
                    <CustomPagination
                      className="pagination-bar justify-content-end find-doctor-pagination"
                      currentPage={pagination?.PageNumber}
                      totalCount={pagination?.TotalRecords}
                      siblingCount={1}
                      pageSize={pagination?.PageSize}
                      onPageChange={(page) => {
                        pageChangeHandler(page);
                      }}
                      accessibilityPagination={true}
                      accessibilityCurrentPage={accessibilityCurrentPage}
                      setAccessibilityCurrentPage={setAccessibilityCurrentPage}
                    />
                  </Col>
                ) : null}
              </Row>
            )}

            {data &&
              data.map((ele, i) => {
                return (
                  <Fragment key={i}>
                    <ResultCard
                      coveredCostLoading={coveredCostLoading}
                      elemkey={`${ele.PhysicianID}${i}`}
                      data={ele}
                      isAccordion={true}
                      setSelectedCheckedItems={setSelectedCheckedItems}
                      selectedCheckedItems={selectedCheckedItems}
                      setSelectedCheckedRowData={setSelectedCheckedRowData}
                      selectedCheckedRowData={selectedCheckedRowData}
                      serachNetworksFor={serachNetworksFor}
                      CoveredCostComparePriceArray={
                        CoveredCostComparePriceArray
                      }
                      isExternalProvider={isExternalProvider}
                    />
                  </Fragment>
                );
              })}

            {pagination && (
              <Row className="my-4">
                <Col md={7}>
                  {/*<NumberOfItemsSelect
                    pagination={pagination}
                    dataLength={data?.length || 0}
                    pageSizeHandler={pageSizeHandler}
                    isSuffixMessageVisible
                  /> */}
                </Col>
                {pagination?.TotalRecords > displayPaginationMininumCount ? (
                  <Col md={5}>
                    <CustomPagination
                      className="pagination-bar justify-content-end"
                      currentPage={pagination?.PageNumber}
                      totalCount={pagination?.TotalRecords}
                      siblingCount={1}
                      pageSize={pagination?.PageSize}
                      onPageChange={(page) => {
                        pageChangeHandler(page);
                      }}
                      accessibilityPagination={true}
                      accessibilityCurrentPage={accessibilityCurrentPage}
                      setAccessibilityCurrentPage={setAccessibilityCurrentPage}
                    />
                  </Col>
                ) : null}
              </Row>
            )}
          </>
        )}

        {isSearchingProviders && (
          <div className="mt-5">
            {[0, 1, 2].map((ele, i) => {
              return (
                <Fragment key={i}>
                  <ResultsCardSkeleton />
                </Fragment>
              );
            })}
          </div>
        )}

        {(noResultsFound || (!isSearchingProviders && data?.length === 0)) && (
          <DataNotFound searchText={searchTerm} />
        )}
      </Container>
      <Container>
        {showServerError && (
          <CustomClientError
            ErrorHeading="Something went wrong with the request!"
            ErrorMessage="Please try again."
            CustomClasses="p-0 m-0"
          />
        )}
      </Container>
      <BottomSideBar
        selectedCheckedItems={selectedCheckedItems}
        selectedCheckedRowData={selectedCheckedRowData}
        tableRef={tableRef}
      ></BottomSideBar>

      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default SearchResults;
